import {
  ContextField,
  ContextSelectedOptions,
  ContextSelector
} from "@appretio/context-selector";
import { Button, DataTable, Sheet } from "@appretio/ui-kit";
import { GridOptions } from "ag-grid-enterprise";
import { useMemo, useState } from "react";
import { activeDeactivateCellRenderer } from "../../components/demo-dataTable/cellRenderComponent/activateDeactivateCellRender";
import {
  contextActionsContainer,
  contextContainer,
  contextSelectorsContainer
} from "./TradexPage.css";

/**
 * Handles which values are fetched and displayed by the ContextSelector
 */
const LIFECYCLE_CONTEXT_OPTIONS: ContextField[] = [
  "brand",
  "sub_brand",
  "product_line",
  "collection_type",
  "product_category",
  "collection_name",
  "country",
  "sales_location"
];

export function TradexPage() {
  const [selectedContextOptions, setSelectedContextOptions] =
    useState<ContextSelectedOptions>({});

  function clearSelectedOption() {
    setSelectedContextOptions({});
  }

  const gridOptions: GridOptions = useMemo(
    () => ({
      enableGroupEdit: true,
      suppressScrollOnNewData: true,
      cellSelection: true,
      autoGroupColumnDef: {
        headerName: "Style Option ID",
        pinned: "left",
        width: 100
      },
      columnTypes: {
        activation: {
          cellRenderer: activeDeactivateCellRenderer,
          cellStyle: { textAlign: "center" },
          width: 50
        }
      }
    }),
    []
  );

  return (
    <>
      <Sheet>
        <div className={contextContainer}>
          <div className={contextSelectorsContainer}>
            <ContextSelector
              fields={LIFECYCLE_CONTEXT_OPTIONS}
              selected={selectedContextOptions}
              setSelected={setSelectedContextOptions}
            />
          </div>
          <div className={contextActionsContainer}>
            <Button variant="secondary" onClick={clearSelectedOption}>
              Clear
            </Button>
            <Button>Apply</Button>
          </div>
        </div>
      </Sheet>
      <Sheet>
        <div style={{ height: "calc(100vh - 14rem)", width: "100%" }}>
          <DataTable
            rowData={[]}
            columnDefs={[]}
            rowHeight={75}
            gridOptions={gridOptions}
          />
        </div>
      </Sheet>
    </>
  );
}
